import classnames from 'classnames';
import {SvgIcon, SvgIconName} from '@shipwell/shipwell-ui';

const TimelineIcon = ({
  isLineHidden,
  iconToShow,
  iconColor,
  showFlag
}: {
  isLineHidden: boolean;
  iconToShow: SvgIconName;
  iconColor?: string;
  showFlag?: boolean;
}) => {
  const isNumIcon = iconToShow.match(/Num[0-9]{1,}/);
  const numberInsideOfIconToShow = isNumIcon ? iconToShow.match(/\d+/)?.at(0) : null;

  return (
    <div className="mr-1 flex flex-col">
      <div>
        {!isNumIcon && <SvgIcon name={iconToShow} color={iconColor ?? 'sw-primary'} />}

        {isNumIcon && (
          <div
            role="status"
            aria-label="stop number"
            className="flex size-6 items-center justify-center rounded-full bg-sw-primary text-xxs font-bold leading-normal text-[#fff]"
          >
            {numberInsideOfIconToShow}
          </div>
        )}

        {showFlag && <SvgIcon name="FlagFilled" color="sw-error" />}
      </div>

      {isLineHidden ? null : (
        <div
          className={classnames('ml-[11px] h-full  w-[2px]', {
            'bg-sw-border-light': !iconColor,
            'bg-sw-disabled': iconColor
          })}
        />
      )}
    </div>
  );
};

export default TimelineIcon;
